import {
  construirPartidasConDetalle,
  getHashedRows,
  getIncrementosDeduccionesCalculados,
  toNumber,
} from "../../services/mappings";
import DocumentHeader from "./partials/DocumentHeader";
import ItemsTable from "./partials/ItemsTable";
import TotalRow from "./partials/TotalRow";
import ItemsSubTotal from "./partials/ItemsSubTotal";
import IncrementsTable from "./partials/IncrementsTable";
import NetTotal from "./partials/NetTotal";
import DocumentFooter from "./partials/DocumentFooter";

function DefaultPDF({ headers, partidas, incrementos, detalles, contract, applicationRoles }) {
  const itemsList = construirPartidasConDetalle(partidas, detalles);
  const hashRows = getHashedRows(detalles);

  const sumDetalle = (arr, key) =>
    arr.reduce((acc, r) => acc + toNumber(r?.detalle?.[key]), 0);

  const mainPartidas = Array.isArray(itemsList?.data) ? itemsList.data : [];

  const baseScTot = sumDetalle(mainPartidas, "montO_TOTCONT_MONTO_BASE_MC");
  const baseAmaTot = sumDetalle(mainPartidas, "acuM_ANTERIOR_MONTO_PAGO_MC");
  const basePaVmb = sumDetalle(mainPartidas, "eP_MES_MONTO_BASE_MC");
  const basePaMr = sumDetalle(mainPartidas, "eP_MES_REAJUSTE_MC");
  const basePaTot = sumDetalle(mainPartidas, "eP_MES_MONTO_PAGO_MC");
  const baseTaTot = sumDetalle(mainPartidas, "acuM_MONTO_PAGO_MC");

  const hashScTot = sumDetalle(hashRows, "montO_TOTCONT_MONTO_BASE_MC");
  const hashAmaTot = sumDetalle(hashRows, "acuM_ANTERIOR_MONTO_PAGO_MC");
  const hashPaVmb = sumDetalle(hashRows, "eP_MES_MONTO_BASE_MC");
  const hashPaMr = sumDetalle(hashRows, "eP_MES_REAJUSTE_MC");
  const hashPaTot = sumDetalle(hashRows, "eP_MES_MONTO_PAGO_MC");
  const hashTaTot = sumDetalle(hashRows, "acuM_MONTO_PAGO_MC");

  const subtotalScTot = baseScTot + hashScTot;
  const subtotalAmaTot = baseAmaTot + hashAmaTot;
  const subtotalPaVmb = basePaVmb + hashPaVmb;
  const subtotalPaMr = basePaMr + hashPaMr;
  const subtotalPaTot = basePaTot + hashPaTot;
  const subtotalTaTot = baseTaTot + hashTaTot;

  const { subAma, subPa, subTa } = getIncrementosDeduccionesCalculados(
    detalles,
    incrementos,
  );

  const netTotals = {
    ama: subtotalAmaTot + subAma,
    mb: subtotalPaVmb,
    mr: subtotalPaMr,
    mt: subtotalPaTot + subPa,
    af: subtotalTaTot + subTa,
  };
  const moneda = headers?.data?.moneda ?? headers?.moneda ?? "";

  return (
    <>
      <DocumentHeader headers={headers} contract={contract} />
      {/* Tabla de Partidas */}
      <ItemsTable items={itemsList} hashRows={hashRows} />
      <TotalRow title="TOTAL PARTIDAS CONTRATO" value={subtotalScTot} />
      <TotalRow
        title="VALOR VIGENTE DEL CONTRATO"
        value={contract?.data?.amount ?? ""}
      />

      <ItemsSubTotal
        amaTot={subtotalAmaTot}
        paVmb={subtotalPaVmb}
        paMr={subtotalPaMr}
        paTot={subtotalPaTot}
        taTot={subtotalTaTot}
      />

      <IncrementsTable incrementos={incrementos} detalles={detalles} />
      <NetTotal
        detalles={detalles}
        incrementos={incrementos}
        totals={netTotals}
        moneda={moneda}
      />
      <DocumentFooter headers={headers} applicationRoles={applicationRoles} />
    </>
  );
}

export default DefaultPDF;
